import { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";

const GlobalStateContext = createContext(undefined);

export function GlobalStateProvider({ children }) {
  const [isLoading, setIsLoading] = useState(false);

  const handleApiResponse = async (response) => {
    if (!response) {
      throw new Error("No response received");
    }

    const { returnCode, returnMessage } = response;

    if (returnCode >= 200 && returnCode < 300) {
      if (returnMessage) {
        toast.success(returnMessage);
      }
      return response;
    } else {
      throw new Error(returnMessage || "An error occurred");
    }
  };

  const handleApiError = (error) => {
    const message =
      error.response?.data?.message || error.message || "An error occurred";

    if (message.toString().includes("JWT expired")) {
      toast.error(message);

      // Handle token refresh or logout
      localStorage.removeItem("token");
      localStorage.removeItem("loggedInUser");
      localStorage.removeItem("persist:auth");
      window.location.href = "/login";
    }
    throw error;
  };

  return (
    <GlobalStateContext.Provider
      value={{
        isLoading,
        setIsLoading,
        handleApiResponse,
        handleApiError,
      }}
    >
      {children}
      {isLoading && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-4 rounded-lg shadow-lg flex items-center space-x-3">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            <span className="text-gray-700">Loading...</span>
          </div>
        </div>
      )}
    </GlobalStateContext.Provider>
  );
}

export function useGlobalState() {
  const context = useContext(GlobalStateContext);
  if (context === undefined) {
    throw new Error("useGlobalState must be used within a GlobalStateProvider");
  }
  return context;
}
